const dlnrt = "dlnrt";
const lnr = "lnr";

import { VOWELS } from "./constants";
export function letterIsVowel(letter) {
  return VOWELS.indexOf(letter.toLowerCase()) >= 0;
}

export function letterIsNRL(letter) {
  return "lnr".indexOf(letter.toLowerCase()) >= 0;
}

export function letterIsS(letter) {
  return "s".indexOf(letter.toLowerCase()) >= 0;
}

export function letterIsBCFGMP(letter) {
  return "bcfgmpt".indexOf(letter.toLowerCase()) >= 0;
}

export function letterIsGD(letter) {
  return "gd".indexOf(letter.toLowerCase()) >= 0;
}

export function letterIs(letter, match) {
  if (letter) return match.indexOf(letter.toLowerCase()) >= 0;
  else return false;
}

export function firstLetter(str) {
  return str.substring(0, 1);
}

export function lastLetter(str) {
  return str[str.length - 1];
}

export function nthLetter(str, n) {
  if (n < str.length) return str[n];
  else console.error("index out of bounds");
}

export function startsWith(str, match) {
  return str.toLowerCase().substring(0, match.length) === match.toLowerCase();
}

export function endsWith(str,match){
  return str.toLowerCase().substring(match.length - 1, match.length) === match.toLowerCase();
}

export function firstVowelGroup(str) {
  var result = "";
  for (var i = 0; i < str.length; i++) {
    if (letterIsVowel(str[i])) {
      result += str[i];
    } else if (result.length > 0) {
      return result;
    }
  }
  return "";
}

export function firstVowelPos(str) {
  for (var i = 0; i < str.length; i++) {
    if (letterIsVowel(str[i])) {
      return i;
    }
  }
}

export function beginsWithVowel(str) {
  return letterIsVowel(firstLetter(str));
}

export function lenite(str) {
  return firstLetter(str) + "h" + str.substring(1);
}

export function beginsDLNRT(str) {
  return dlnrt.indexOf(firstLetter(str)) >= 0;
}

export function beginsWithS(str) {
  return firstLetter(str) === "s";
}
export function beginsBCFGMP(str) {
  return letterIsBCFGMP(firstLetter(str));
}
